import React, { useContext } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import { StatusIcon } from "components/common";
import Store from "logic/local-storage/Store";
import { ApiRoutes } from "./common/Routes";
import { toAWSCloudTrailInputCreateRequest } from "./common/formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      line-height: 2;
      padding: 0 5px;

      &:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong::after {
      content: ':';
      margin-right: 5px;
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.awsCloudTrailThrottleEnabled) == null ? void 0 : _a.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toAWSCloudTrailInputCreateRequest(formData)
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to save your Input, please try again in a few moments.")
  } : null;
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.AWSCloudTrail.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Save and Start Input",
      loading: saveInput.loading,
      error: formError,
      description: "Check out everything below to make sure it's correct, then click the button below to complete your AWS CloudTrail setup!"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, "Input Configuration"), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Name "), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailName.value)), ((_b = formData.awsAccessKey) == null ? void 0 : _b.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Access Key "), /* @__PURE__ */ React.createElement("span", null, (_c = formData.awsAccessKey) == null ? void 0 : _c.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "SQS Region "), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailSqsRegion.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "S3 Region "), /* @__PURE__ */ React.createElement("span", null, formData.awsCloudTrailS3Region.value)), ((_d = formData.awsAssumeRoleARN) == null ? void 0 : _d.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Assume Role (ARN) "), /* @__PURE__ */ React.createElement("span", null, (_e = formData.awsAssumeRoleARN) == null ? void 0 : _e.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS SQS Queue name "), /* @__PURE__ */ React.createElement("span", null, (_f = formData.awsCloudTrailSqsQueueName) == null ? void 0 : _f.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "SQS Message Batch Size "), /* @__PURE__ */ React.createElement("span", null, (_g = formData.sqsMessageBatchSize) == null ? void 0 : _g.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Polling Interval "), /* @__PURE__ */ React.createElement("span", null, formData.pollingInterval.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Enable Throttling"), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled })))))
  );
};
export default StepReview;
